module.exports = __webpack_public_path__ + "static/media/chat_background.5c9bbe3b.png";